import { useState, useContext, useEffect } from 'react';
import { StorefrontContext } from '../store/StorefrontContext.jsx';
import { Button } from 'react-bootstrap';
import { ProductCoilSettingContext } from '../store/ProductCoilSettingContext.jsx';
const RefetchButton = () => {
    const { state: storefrontStateObject, fetchMetaObject } = useContext(StorefrontContext);
    const { productCoilSetting, updateProductCoilSetting } = useContext(ProductCoilSettingContext);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (storefrontStateObject?.metaObject) {
            setLoading(false)
            console.log('storefrontStateObject updates', storefrontStateObject);
        }
    }, [storefrontStateObject]);

    return (
        <Button
            variant="outline-success"
            size="lg"
            className="btn-refresh"
            onClick={() => {
                if (loading) return
                setLoading(true)
                fetchMetaObject()
            }}
            disabled={loading}
            style={{
                position: 'fixed',
                bottom: '10px',
                left: '10px',
            }}
        >
            <i className="bi bi-arrow-clockwise"></i>
        </Button>
    );
}

export default RefetchButton;